export const GET_FEATURE_FLAGS = 'GET_FEATURE_FLAGS';

export const getFeatureFlags = (data: any) => ({
    type: GET_FEATURE_FLAGS,
    data
});
